import Hero from "@/components/Hero";
import About from "@/components/About";
import ProcessTimeline from "@/components/ProcessTimeline";
import PerformanceChart from "@/components/PerformanceChart";
import InvestmentJourney from "@/components/InvestmentJourney";
import GoalCards from "@/components/GoalCards";
import ContactForm from "@/components/ContactForm";
import CalculatorsTeaser from "@/components/CalculatorsTeaser";
import QuizTeaser from "@/components/QuizTeaser";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function HomePage() {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      }, 80);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <>
      <Hero />
      <About />
      <ProcessTimeline />
      <PerformanceChart />
      <InvestmentJourney />
      <CalculatorsTeaser />
      <QuizTeaser />
      <GoalCards />
      <ContactForm />
    </>
  );
}
